import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {StatutePageComponent} from './statute-page.component';

const routes: Routes = [
  {
    component: StatutePageComponent,
    path: ''
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class StatutePageRoutingModule {
}
